const globalStyle = '';
export default globalStyle;
//# sourceMappingURL=globalStyle.js.map